import AScene from "../../library/ExtendedObjects/AScene.js";
import LikeEffect from "../game/LikeEffect.js";
import Utils from "../../library/Utils.js";

export default class End extends AScene
{
    static get KEY() { return 'End'; }
    constructor()
    {
        super({ key: (End).KEY });
    }

    init()
    {
        let bg = this.addImage(this.mid.x, this.mid.y, "Background");
        let youKnockedItOutOFThePark = this.addImage(this.mid.x, this.mid.y - 400, "YouKnockedIt");
        let title = this.addImage(this.mid.x, this.mid.y - 500, "EndTitle");
        
        let phoneBG = this.addImage(-18, 12, "Phone");
        phoneBG.setScale(1.375);
        let game = this.add.image(0, 0, 'game');

        let phoneContainer = this.add.container(this.mid.x, this.mid.y, [phoneBG, game]);

        this.likes = new LikeEffect(this);
        this.likes.playEffect();

        this.addTween(phoneContainer, 1000, {scaleX: .5, scaleY: .5, x: this.mid.x + 10, y: this.mid.y + 115, angle: 40}, Phaser.Math.Easing.Back.Out, ()=>{
            let x = phoneContainer.x;
            let y = phoneContainer.y;
            this.addTween(phoneContainer, 30, {x: x + 7, y: y + 4, yoyo: true, repeat: 15}, Phaser.Math.Easing.Expo.Out);
            this.playSound("smartphone");
        });

        let restartBtn = this.addButton(this.size.width - 125, this.size.height - 125, "RestartButton", {tintOnDown: 0xaaaaaa}, ()=>{
            Utils.TransitionScenes(this, "Intro", 1000, -1, 0);
            this.addDelay(1000, ()=>{
                
            });

            this.game.scene.keys.Game.scene.stop();
        });

        title.alpha = 0;
        youKnockedItOutOFThePark.alpha = 0;
        restartBtn.alpha = 0;
        title.setScale(.5);
        restartBtn.setScale(2);
        

        this.addTween(title, 1000, {alpha: 1, y: this.mid.y - 400, scaleX: 1, scaleY: 1, delay: 400}, Phaser.Math.Easing.Expo.Out);
        this.addTween(youKnockedItOutOFThePark, 1000, {alpha: 1, y: this.mid.y - 300, delay: 700}, Phaser.Math.Easing.Expo.Out);
        this.addTween(restartBtn, 1000, {alpha: 1, scaleX: 1, scaleY: 1, delay: 800}, Phaser.Math.Easing.Expo.Out);
    }

    update(time, delta)
    {
        if(this.likes != null) 
        {   
            this.likes.update(delta);
        }
    }
}